/**
 * Escape text that is about to be wrapped in HTML.
 *
 * The server sanitises everything on write, so this is not the security
 * boundary — it is correctness. A task called `Fix <img> handling` should keep
 * those angle brackets rather than lose the word to a stripped tag.
 *
 * Shared because two places now build a one-paragraph body from a plain
 * string, and the second copy is where the `&` case gets forgotten.
 */
export function escapeHtml(s: string): string {
  return s.replace(/[<>&"']/g, (c) => ESCAPES[c]!);
}

const ESCAPES: Record<string, string> = {
  '<': '&lt;',
  '>': '&gt;',
  '&': '&amp;',
  '"': '&quot;',
  "'": '&#39;',
};
